export default "/images/bb5ccc994a80b6404cb6cc4ceb564987.avif";